<template>
    <div class="pt-8">
        <filter-form 
            :filter="filter" 
            :paymentStateList="paymentStateList"
            @get-all-pedidos="getAllpedidos()" 
            @clear-filter-form="clearFilterForm()" 
        />

        <pedidos-table 
            :pedidos="pedidos" 
            :paginator="paginator" 
            :pageSize="pageSize"  
            @get-all-pedidos="getAllpedidos()" 
            @change-page="changePage($event)" 
            @synchronize-orders="synchronizeOrders()"
            @download-excel="downloadExcel()"
        />
    </div>

</template>
<script>
import PedidosTable from '../components/PedidosTable.vue'
import FilterForm from '../components/FilterForm.vue'
import { mapMutations } from 'vuex'
export default {
    data(){
        return{
            pedidos: [],
            paginator: {
                page: 1,
                totalPage: 1,
                pageSize: 50,
            },
            pageOptions: "",
            pageSize: [50, 100],
            paymentStateList: [
                { id: 'not_paid', label: 'No pagado' },
                { id: 'in_payment', label: 'En proceso de pago' },
                { id: 'paid', label: 'Pagado' },
                { id: 'partial', label: 'Pagado parcialmente' },
                { id: 'reversed', label: 'Revertido' },
            ],
            filter: {
                paymentState: "",
                pedidoId: "",
                vendedor: "",
                dateFrom: "",
                dateTo: new Date().toISOString().substr(0, 10),
            }
           
        }
    },
    components: {
        PedidosTable,
        FilterForm
    },
    created(){
        this.getAllpedidos();
    },
    methods:{
        ...mapMutations(['setLoading']),
        async getAllpedidos() {
            this.setLoading(true)
            if(typeof this.pedidoStatus === "undefined"){
                this.pedidoStatus = "";
            }
            
            this.pageOptions = { 
                pageNumber:   this.paginator.page, 
                pageSize:     this.paginator.pageSize,
                pedidoId:     this.filter.pedidoId,
                vendedor:     this.filter.vendedor,
                paymentState: this.filter.paymentState,
                dateFrom:     this.filter.dateFrom,
                dateTo:       this.filter.dateTo,
            }
            await this.$conectar.post('pedidos/proveedor/get-all-pedidos', this.pageOptions)
            .then(response =>{
                this.pedidos = response.data.pedidosLists;
                this.paginator.totalPage = response.data.totalPages;
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        changePage(page){
            this.paginator.page = page;
            this.getAllpedidos();
        },
        clearFilterForm(){
            this.filter.pedidoId = "";
            this.filter.vendedor = "";
            this.filter.paymentState = "";
            this.filter.dateFrom = "";
            this.filter.dateTo = new Date().toISOString().substr(0, 10);
            this.paginator.pageSize = 50;
        },
        async synchronizeOrders(){
            this.setLoading(true)
            await this.$conectar.post('pedidos/proveedor/get-order-status-from-supplier')
            .then(response =>{
                if(response.data.error == false){
                    this.getAllpedidos();
                    this.$bvToast.toast("Pagos sincronizados con exito!", {
                        title: "Respuesta del servidor",
                        variant: "success",
                        solid: true
                    })
                }else{
                    this.$bvToast.toast("Error al sincronizar el estado de las ordenes, por favor contactar al soporte", {
                        title: "Respuesta del servidor",
                        variant: "danger",
                        solid: true
                    })
                }
            })
            .catch(e => {
                console.log(e.response);
                this.$bvToast.toast("Error al sincronizar el estado de las ordenes, por favor contactar al soporte", {
                    title: "Respuesta del servidor",
                    variant: "danger",
                    solid: true
                })
            })
            this.setLoading(false)
        },
        async downloadExcel() {
            this.setLoading(true)
            try {
                const filters = {
                    pedidoId:     this.filter.pedidoId,
                    vendedor:     this.filter.vendedor,
                    paymentState: this.filter.paymentState,
                    dateFrom:     this.filter.dateFrom,
                    dateTo:       this.filter.dateTo,
                };

                const response = await this.$conectar.post(
                    'pedidos/proveedor/download-order-excel', 
                    filters, 
                    { responseType: 'blob' }
                );

                // Verificar si la respuesta es JSON con error
                const contentType = response.headers['content-type'];
                if (contentType.includes('application/json')) {
                    const reader = new FileReader();
                    reader.onload = () => {
                        try {
                            const jsonResponse = JSON.parse(reader.result);
                            if (jsonResponse.error) {
                                this.$bvToast.toast(jsonResponse.message, {
                                    title: 'Alerta',
                                    variant: 'danger',
                                    solid: true
                                });
                            }
                        } catch (err) {
                            console.error('Error procesando la respuesta JSON:', err);
                        }
                    };
                    reader.readAsText(response.data);
                    return;
                }

                // Generar nombre de archivo con timestamp
                const timestamp = new Date().toISOString().replace(/[-T:]/g, "").slice(0, 12); // YYYYMMDDHHMM
                const fileName = `Pedidos_Proveedor_${timestamp}.xlsx`;

                // Crear y descargar archivo
                const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');

                link.href = url;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();

                // Limpiar URL del blob
                URL.revokeObjectURL(url);
                document.body.removeChild(link);

            } catch (error) {
                console.error('Error al descargar el archivo:', error);
                this.$bvToast.toast('Error al descargar el archivo Excel.', {
                    title: 'Error',
                    variant: 'danger',
                    solid: true
                });
            } finally {
                this.setLoading(false);
            }
        }
    }
}
</script>